import styled from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'

import type { FC } from 'react'

export type DataPoint = {
  label: string
  value?: string | number | boolean
  date?: string
}

export type DataPointEntryProps = {
  dataPoint: DataPoint
}

const DataPointEntry: FC<DataPointEntryProps> = ({ dataPoint }) => {
  return (
    <StDataPointEntry>
      <Span type='BodyMediumRegular' style={{ fontWeight: 500 }}>
        {dataPoint.label}
      </Span>
      {dataPoint?.value ? (
        <Span type='BodyMediumRegular' style={{ fontWeight: 400 }}>
          {dataPoint.value}
        </Span>
      ) : null}
    </StDataPointEntry>
  )
}

const StDataPointEntry = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: ${({ theme }) => theme.UI.SpacingPx.Space2};

  color: ${({ theme }) => theme.Colors.Neutrals.Darker};

  padding: ${({ theme }) => theme.UI.SpacingPx.Space3}
    ${({ theme }) => theme.UI.SpacingPx.Space4};

  background-color: ${({ theme }) => theme.Colors.Neutrals.Lighter};
`

export { DataPointEntry }
